<template>
  <div class="customerOrder">
    <div class="header">
      <el-tabs value="first">
        <el-tab-pane label="销售订单" name="first">
          <span class="activeLink">销售订单</span>
          <div class="btnBox">
            <div class="searchBtnBox" style="margin-right:15px">
              <el-tooltip class="item" content="只看我的工单" placement="bottom" :open-delay="300">
                <el-checkbox v-model="searchConditionForm.onlyMy" @change="onlyMyChange">我的工单</el-checkbox>
              </el-tooltip>
            </div>
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip class="item" content="清除查询条件" placement="bottom" :open-delay="300">
                <el-button icon="iconfont icon-qingkong" size="small"
                  class="cleanBox" @click="onClear"></el-button>
              </el-tooltip>
              <el-button type="primary" icon="el-icon-search" size="small" @click="onSearch">查询</el-button>
            </div>
            <el-button type="primary" icon="el-icon-plus" size="small" @click="addNewBtn">新建</el-button>
            <el-tooltip class="item" content="查询条件" placement="bottom" :open-delay="300">
              <el-button
                class="btn_more"
                :class="{activeUserMore:isMoreSearch}"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-form
        :inline="true"
        :model="searchConditionForm"
        class="demo-form-inline"
        v-if="isMoreSearch"
      >
        <div class="searchConditionBox">
          <el-form-item label="销售单号" size="small">
            <el-input v-model="searchConditionForm.orderNumber" placeholder="销售订单号" clearable
              @keyup.enter.native="getCustomerOrderSearch()"></el-input>
          </el-form-item>
          <el-form-item label="客户" size="small">
            <el-select
              v-model="searchConditionForm.customerId"
              placeholder="选择客户名称"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.customerList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户PO" size="small">
            <el-input v-model="searchConditionForm.customerPo" placeholder="客户采购订单号" clearable
              @keyup.enter.native="getCustomerOrderSearch()"></el-input>
          </el-form-item>
          <el-form-item label="销售员" size="small">
            <el-input v-model="searchConditionForm.sales" placeholder="销售员" clearable
              @keyup.enter.native="getCustomerOrderSearch()"></el-input>
          </el-form-item>
          <el-form-item label="产品类别" size="small">
            <el-select
              v-model="searchConditionForm.productType"
              placeholder="选择产品类别"
              filterable
              clearable
              @change="productTypeChange"
            >
              <el-option
                v-for="(item, index) in pullDownData.productTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品型号" size="small">
            <el-select
              v-model="searchConditionForm.productId"
              placeholder="选择产品型号"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.productList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" size="small">
            <el-date-picker
              v-model="searchConditionForm.startDate"
              type="date"
              placeholder="下单开始时间"
              value-format="yyyy-MM-dd"
              @change="startDateChange"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" size="small">
            <el-date-picker
              v-model="searchConditionForm.endDate"
              type="date"
              placeholder="下单结束时间"
              @change="endDateChange"
              value-format="yyyy-MM-dd"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="订单状态" size="small">
            <el-select
              v-model="searchConditionForm.status"
              placeholder="选择订单状态"
              filterable
              clearable
              multiple
              collapse-tags
            >
              <el-option
                v-for="(item, index) in pullDownData.statusList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所有者" size="small">
            <el-select
              v-model="searchConditionForm.userId"
              placeholder="选择工单所有者"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="
                selectVisible($event, 'user', '员工选择', 'searchConditionForm')
              "
            >
              <el-option
                v-for="(item, index) in pullDownData.userList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="contentBox">
      <div class="rightContent">
        <el-table
          stripe
          :data="tableData"
          border
          style="width: 100%"
          height="100%"
          size="mini"
          @sort-change="sortChange"
          :span-method="objectSpanMethod"
        >
          <el-table-column type="index" :width="pagination.endIndex >= 1000 ? 80:50" align="center" :index="pagination.beginIndex"></el-table-column>
          <el-table-column
            prop="orderNumber"
            label="销售单号"
            min-width="110px"
            align="center"
            show-overflow-tooltip
            sortable="custom"
          >
            <template slot-scope="scope">
              <span class="allowSkip" @click="clickAllowSkip(scope.row)">{{scope.row.orderNumber}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="customerId"
            label="客户"
            min-width="110px"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.customer">{{scope.row.customer.name}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="customerPo" label="客户PO" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.customerPo">{{scope.row.customerPo}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="quantity" label="销售数量" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.quantity">{{scope.row.quantity}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="orderNumber" label="组装工单" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span
                v-if="scope.row.productionOrder.orderNumber"
              >{{scope.row.productionOrder.orderNumber}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="productId" label="产品型号" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span
                v-if="scope.row.productionOrder.product"
              >{{scope.row.productionOrder.product.code}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="quantity" label="组装工单数量" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span
                v-if="scope.row.productionOrder.quantity"
              >{{scope.row.productionOrder.quantity}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="orderDate" label="下单时间" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.orderTime">{{scope.row.orderTime}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>          
          <el-table-column prop="sales" label="销售员" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.sales">{{scope.row.sales.name}} ({{scope.row.sales.employeeNum}})</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="status" width="95px" label="状态" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="textOverflow"
                v-if="scope.row.productionOrder.status"
              >{{scope.row.productionOrder.status.title}}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :pagination="pagination"
          @currentChange="currentChange"
          @sizeChange="sizeChange"
          @refreshBtn="getCustomerOrderSearch"
        ></pagination>
      </div>
    </div>
    <myDialog
      ref="myDialog"
      :title="dialogTitle"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="650px"
    >
      <template slot="content">
        <el-dialog
          class="myDialog checkProduct"
          width="500px"
          top="50vh"
          title="选择产品"
          :visible.sync="productVisible"
          append-to-body
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          @close="closeCheckProduct"
          v-dialogDrag
        >
          <el-steps
            class="productSteps"
            :active="productPagenum"
            finish-status="success"
            align-center
          >
            <el-step title="产品型号" @click.native="stepClick(0)"></el-step>
            <el-step title="基本信息" @click.native="stepClick(1)"></el-step>
            <el-step title="生产信息" @click.native="stepClick(2)"></el-step>
            <el-step title="扩展信息" @click.native="stepClick(3)"></el-step>
            <el-step title="版本信息" @click.native="stepClick(4)"></el-step>
            <el-step title="校验信息" @click.native="stepClick(5)"></el-step>
          </el-steps>
          <el-form
            ref="productForm"
            :model="productForm"
            :rules="productRules"
            :label-width="labelWidth"
          >
            <div v-if="productPagenum == 0" key="1">
              <el-form-item label="产品类别" size="small" prop="productType">
                <el-select
                  v-model="productForm.productType"
                  placeholder="选择产品类别"
                  filterable
                  clearable
                  @change="addProductTypeChange"
                  :disabled="isEditProduct"
                >
                  <el-option
                    v-for="(item, index) in pullDownData.productTypeList"
                    :key="index"
                    :label="item.title"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="产品型号" size="small" prop="productId">
                <el-select
                  v-model="productForm.productId"
                  placeholder="选择产品型号"
                  filterable
                  clearable
                  @change="productIdChange"
                  :disabled="isEditProduct"
                >
                  <el-option
                    v-for="(item, index) in pullDownData.addProductList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="下单数量" size="small" prop="quantity">
                <el-input
                  :value="productForm.quantity"
                  @input="$event => $set(productForm, 'quantity', $event.replace(/[^\d]/g,'').replace(/^0{1,}/g,''))"
                  placeholder="下单数量"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="成品编码" size="small" prop="itemCode">
                <el-input v-model="productForm.itemCode" placeholder="ERP里的成品编码" clearable></el-input>
              </el-form-item>
            </div>
            <div v-else-if="productPagenum == 1" key="2">
              <el-form-item label="客户料号" size="small" prop="partNumber">
                <el-input v-model="productForm.partNumber" placeholder="输入客户料号" clearable></el-input>
              </el-form-item>
              <el-form-item label="自定义型号" size="small" prop="customerModel">
                <el-input v-model="productForm.customerModel" placeholder="客户自定义型号" clearable></el-input>
              </el-form-item>
              <el-form-item label="自定义版本" size="small" prop="customerEdition">
                <el-input v-model="productForm.customerEdition" placeholder="客户自定义版本" clearable></el-input>
              </el-form-item>
              <el-form-item label="产品规格" size="small" prop="gauge">
                <el-input v-model="productForm.gauge" placeholder="如：欧规、美规、一拖N套装等" clearable></el-input>
              </el-form-item>
            </div>
            <div v-else-if="productPagenum == 2" key="3">
              <el-form-item label="SN模版" size="small" prop="snPrefix">
                <el-input
                  class="inlineItem"
                  v-model="productForm.snPrefix"
                  placeholder="输入SN模版"
                  clearable
                  :disabled="!productForm.createSn"
                ></el-input>
                <el-checkbox class="inlineItem" v-model="productForm.createSn" @change="createSnChange">创建时生成SN</el-checkbox>
              </el-form-item>
              <el-form-item label="流水长度" size="small" prop="snLen">
                <el-input
                  class="inlineItem"
                  :value="productForm.snLen"
                  @input="onlyNumber($event, 'productForm', 'snLen')"
                  placeholder="SN流水号长度"
                  clearable
                  :disabled="!productForm.createSn"
                ></el-input>
                <el-checkbox class="inlineItem" v-model="productForm.onlyCarton">只使用包装流程</el-checkbox>
              </el-form-item>
              <el-form-item label="起始SN" size="small" prop="startSn">
                <el-input
                  :value="productForm.startSn"
                  @input="onlyNumber($event, 'productForm', 'startSn')"
                  placeholder="输入起始SN"
                  clearable
                  :disabled="!productForm.createSn"
                ></el-input>
              </el-form-item>
              <el-form-item label="厂商信息" size="small" prop="vendor">
                <el-input v-model="productForm.vendor" placeholder="输入厂商信息" clearable></el-input>
              </el-form-item>
              <el-form-item label="默认密码" size="small" prop="defaultPassword">
                <el-input v-model="productForm.defaultPassword" placeholder="输入默认密码" clearable></el-input>
              </el-form-item>
            </div>
            <div v-else-if="productPagenum == 3" key="4">
              <el-form-item label="国家码" size="small" prop="countryCode">
                <el-input v-model="productForm.countryCode" placeholder="输入国家码" clearable></el-input>
              </el-form-item>
              <el-form-item label="EAN码" size="small" prop="eanCode">
                <el-input v-model="productForm.eanCode" placeholder="输入EAN码" clearable></el-input>
              </el-form-item>
              <el-form-item label="PID" size="small" prop="tuyaPid">
                <el-input v-model="productForm.tuyaPid" placeholder="产品PID（涂鸦PID或其他客户定义的PID）" clearable></el-input>
              </el-form-item>
              <el-form-item label="CMIIT ID" size="small" prop="cmiitId">
                <el-input v-model="productForm.cmiitId" placeholder="输入CMIIT ID" clearable></el-input>
              </el-form-item>
              <el-form-item v-show="p2pType == 'DLink'" label="检料单号" size="small" prop="pickSlip">
                <el-input v-model="productForm.pickSlip" placeholder="输入检料单号" clearable></el-input>
              </el-form-item>
              <el-form-item v-show="p2pType == 'DLink'" label="客户PO" size="small" prop="hqPo">
                <el-input v-model="productForm.hqPo" placeholder="客户的订单号" clearable></el-input>
              </el-form-item>
            </div>
            <div v-else-if="productPagenum == 4" key="5">
              <!-- <el-form-item label="Flash版本" size="small" prop="swVersion">
                <el-select
                  v-model="swVersion.id"
                  placeholder="选择Flash版本"
                  filterable
                  clearable
                  class="inlineItem"
                >
                  <el-option
                    v-for="(item, index) in pullDownData.swVersionList"
                    :key="index"
                    :label="item.version"
                    :value="item.id"
                  ></el-option>
                </el-select>
                <el-checkbox class="inlineItem" v-model="swVersion.mustIqc">强制IQC流程</el-checkbox>
              </el-form-item>
              <el-form-item label="MCU版本" size="small" prop="mcuVersion">
                <el-select
                  v-model="mcuVersion.id"
                  placeholder="选择MCU版本"
                  filterable
                  clearable
                  class="inlineItem"
                >
                  <el-option
                    v-for="(item, index) in pullDownData.mcuVersionList"
                    :key="index"
                    :label="item.version"
                    :value="item.id"
                  ></el-option>
                </el-select>
                <el-checkbox class="inlineItem" v-model="mcuVersion.mustIqc">强制IQC流程</el-checkbox>
              </el-form-item> -->
              <el-form-item label="固件版本" size="small" prop="fwVersion">
                <el-input v-model="productForm.fwVersion" placeholder="如:V1.0.1" clearable></el-input>
              </el-form-item>
              <el-form-item label="硬件版本" size="small" prop="hwVersion">
                <el-input v-model="productForm.hwVersion" placeholder="如:V2020.08.13" clearable></el-input>
              </el-form-item>
              <el-form-item label="配置版本" size="small" prop="cfgVersion">
                <el-input v-model="productForm.cfgVersion" placeholder="如:V1.001" clearable></el-input>
              </el-form-item>
              <el-form-item label="系统版本" size="small" prop="osVersion">
                <el-input v-model="productForm.osVersion" placeholder="如:Android 7.0.1" clearable></el-input>
              </el-form-item>
            </div>
            <div v-else-if="productPagenum == 5" key="6">
              <el-form-item label="吞吐量" size="small" prop="bandwidth">
                <el-input
                  :value="productForm.bandwidth"
                  @input="onlyDecimals($event, 'productForm', 'bandwidth')"
                  placeholder="吞吐量带宽(单位：Mbps，精确度0.1)"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="蓝牙名称" size="small" prop="btName">
                <el-input v-model="productForm.btName" placeholder="如:Mixcder E9" clearable></el-input>
              </el-form-item>
              <el-form-item label="最低电量" size="small" prop="minBatt">
                <el-input
                  :value="productForm.minBatt"
                  @input="minBattInput($event, 'productForm', 'minBatt')"
                  placeholder="输入最低电量"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item v-show="wakeup" label="电池容量" size="small" prop="battery">
                <el-input
                  :value="productForm.battery"
                  @input="batteryInput($event, 'productForm', 'battery')"
                  placeholder="输入电池容量"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button
              class="preButton"
              v-show="productPagenum > 0"
              @click="preProductPage"
              size="small"
            >上一步</el-button>
            <el-button
              class="nextButton"
              v-show="productPagenum < 5"
              @click="nextProductPage"
              size="small"
            >下一步</el-button>
            <el-button
              class="okButton"
              v-show="productPagenum >= 2"
              type="primary"
              @click="checkProductSubmit"
              size="small"
            >完 成</el-button>
          </span>
        </el-dialog>
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          :rules="dialogRules"
          :label-width="labelWidth"
        >
          <el-form-item label="销售单号" size="small" prop="orderNumber" class="inlineItem">
            <el-input v-model="dialogForm.orderNumber" placeholder="ERP里的销售单号" clearable></el-input>
          </el-form-item>
          <el-form-item label="客户" size="small" prop="customerId" class="inlineItem">
            <el-select
              v-model="dialogForm.customerId"
              placeholder="选择客户名称"
              filterable
              clearable
              :disabled="productTableData.length>0"
            >
              <el-option
                v-for="(item, index) in pullDownData.customerList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户PO" size="small" class="inlineItem">
            <el-input v-model="dialogForm.customerPo" placeholder="客户采购订单号" clearable></el-input>
          </el-form-item>
          <el-form-item label="销售人员" size="small" class="inlineItem">
            <el-select
              v-model="dialogForm.salesId"
              placeholder="选择销售人员"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="selectVisible($event, 'sales', '员工选择', 'add')"
            >
              <el-option
                v-for="(item, index) in pullDownData.salesAddList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="下单时间" size="small" class="inlineItem">
            <el-date-picker
              v-model="dialogForm.orderDate"
              type="date"
              placeholder="下单时间"
              value-format="yyyy-MM-dd"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="产品" size="small" prop="products">
            <el-table
              stripe
              :data="productTableData"
              class="productTable"
              border
              style="width: 100%"
              height="150"
              size="mini"
            >
              <el-table-column prop="productTypeTitle" label="类别" align="center"></el-table-column>
              <el-table-column prop="productName" label="型号" align="center" min-width="110"></el-table-column>
              <el-table-column prop="quantity" label="数量" align="center" width="90"></el-table-column>
              <el-table-column class-name="operation" label="操作" align="center" width="80px">
                <template slot-scope="scope">
                  <!-- <el-tooltip
                    class="item"
                    effect="dark"
                    content="修改"
                    placement="top"
                    :open-delay="300"
                  >
                    <i
                      @click="editProduct(scope.row)"
                      class="el-icon-edit"
                      style="cursor:pointer;margin-right:10px"
                    ></i>
                  </el-tooltip> -->
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="移除"
                    placement="top"
                    :open-delay="300"
                  >
                    <i
                      @click="deleteProduct($event, scope.row, scope.$index)"
                      class="iconfont icon-yichu"
                      style="cursor:pointer"
                    ></i>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
            <el-button type="primary" @click="checkProductBtn" size="mini">添加</el-button>
          </el-form-item>
          <el-form-item label="备注" size="small">
            <el-input
              type="textarea"
              :rows="2"
              v-model="dialogForm.notes"
              placeholder="备注信息"
              clearable
            ></el-input>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
    <detailPage ref="detailPage" title="销售订单" :nowRowData="nowRowData"></detailPage>
    <orderTableSelect ref="orderTableSelect" @orderTableSubmit="orderTableSubmit"></orderTableSelect>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import {
  apiCustomerOrderSearch,
  apiCustomerList,
  apiProductTypeList,
  apiProductList,
  apiOrderStatusList,
  apiCustomerOrderAdd
} from "@/api/customerOrder.js";
// import { apiFirmwareList } from "@/api/firmwareManage.js";
import detailPage from "./components/detailPage.vue";
import orderTableSelect from "@/components/orderTableSelect.vue";
export default {
  lastModuleConfig: { modulePath: "/homePage/customerOrder" },
  components: {
    pagination,
    myDialog,
    detailPage,
    orderTableSelect
  },
  data() {
    return {
      isMoreSearch: false,
      searchConditionForm: {},
      pullDownData: {
        customerList: [],
        productTypeList: [],
        productList: [],
        addProductList: [],
        statusList: [],
        salesAddList: [],
        // swVersionList: [],
        // mcuVersionList: []
      },
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10
      },
      dialogTitle: "",
      dialogForm: {
        products: []
      },
      dialogRules: {
        orderNumber: [
          { required: true, message: "销售单号不能为空！", trigger: "blur" },
          {
            min: 4,
            max: 64,
            message: "长度在 4 到 64 个字符",
            trigger: "blur"
          }
        ],
        customerId: [
          { required: true, message: "客户名称不能为空！", trigger: "change" }
        ],
        products: [
          { required: true, message: "产品不能为空！", trigger: "change" }
        ]
      },
      isEditProduct: false,
      productVisible: false,
      productPagenum: 0,
      productForm: {
        snPrefix: "AONI_",
        snLen: 5,
        startSn: 1,
        onlyCarton: false,
        createSn: true
      },
      p2pType: "",
      // Flash版本参数
      // swVersion: {
      //   mustIqc: true
      // },
      // MCU版本参数
      // mcuVersion: {},
      // 电池容量显示
      wakeup: false,
      productRules: {
        productType: [
          { required: true, message: "产品类别不能为空！", trigger: "change" }
        ],
        productId: [
          { required: true, message: "产品型号不能为空！", trigger: "change" }
        ],
        quantity: [
          { required: true, message: "下单数量不能为空！", trigger: "blur" }
        ],
        itemCode: [
          { required: true, message: "成品编码不能为空！", trigger: "blur" },
          { min: 4, max: 64, message: "成品编码长度在4~64字符之间！", trigger: "blur" }
        ],
        customerModel: [
          { min: 0, max: 64, message: "长度不能大于64个字符", trigger: "blur" }
        ],
        customerEdition: [
          { min: 0, max: 64, message: "长度不能大于64个字符", trigger: "blur" }
        ],
        gauge: [
          { min: 0, max: 32, message: "长度不能大于32个字符", trigger: "blur" }
        ],
        tuyaPid: [
          { min: 0, max: 32, message: "长度不能大于32个字符", trigger: "blur" }
        ],
        snPrefix: [
          { min: 1, max: 64, message: "长度在 1 到 64 个字符", trigger: "blur" }
        ],
        // snLen: [
        //   { required: true, message: "SN流水号不能为空！", trigger: "blur" }
        // ],
        // startSn: [
        //   { required: true, message: "起始SN不能为空！", trigger: "blur" }
        // ],
        countryCode: [
          { min: 0, max: 64, message: "长度不能大于64个字符", trigger: "blur" }
        ],
        eanCode: [
          { min: 9, max: 13, message: "长度在 9 到 13 个字符", trigger: "blur" }
        ],
        cmiitId: [
          { min: 0, max: 32, message: "长度不能大于32个字符", trigger: "blur" }
        ],
        partNumber: [
          { min: 0, max: 64, message: "长度不能大于64个字符", trigger: "blur" }
        ],
        pickSlip: [
          { min: 0, max: 64, message: "长度不能大于64个字符", trigger: "blur" }
        ],
        hqPo: [
          { min: 0, max: 64, message: "长度不能大于64个字符", trigger: "blur" }
        ],
        fwVersion: [
          { min: 0, max: 64, message: "长度不能大于64个字符", trigger: "blur" }
        ],
        hwVersion: [
          { min: 0, max: 64, message: "长度不能大于64个字符", trigger: "blur" }
        ],
        cfgVersion: [
          { min: 0, max: 64, message: "长度不能大于64个字符", trigger: "blur" }
        ],
        btName: [
          { min: 0, max: 32, message: "长度不能大于32个字符", trigger: "blur" }
        ]
      },
      productTableData: [],
      labelWidth: "80px",
      // labelWidth: this.$store.state.labelWidth,
      // 表格销售列数据
      nowRowData: {}
    };
  },
  methods: {
    // 表格数据
    async getCustomerOrderSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiCustomerOrderSearch({
        ...this.searchConditionForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;

        // 存储已出现的名称
        let obj = {};
        res.data.forEach(item => {
          if (obj[item.orderNumber]) {
            obj[item.orderNumber] += 1;
          } else {
            obj[item.orderNumber] = 1;
          }
        });
        res.data.forEach(item => {
          if (obj[item.orderNumber]) {
            item.rowspan = obj[item.orderNumber];
            obj[item.orderNumber] = 0;
          } else {
            item.rowspan = 0;
          }
        });
        if (callback) callback();
      }
    },
    // 更多查询
    moreSearchBtn() {
      this.isMoreSearch = !this.isMoreSearch;
      this.$moreSearchStyle();
    },
    // 新建销售订单
    addNewBtn() {
      this.dialogTitle = "新建销售订单";
      this.$refs.myDialog.dialogVisible = true;
      this.$set(this.dialogForm, "salesId", this.$store.state.userInfo.id);
      this.$set(this.pullDownData, "salesAddList", [
        this.$store.state.userInfo
      ]);
    },
    // 添加产品
    checkProductBtn() {
      if (this.dialogForm.customerId) {
        this.productVisible = true;
        this.isEditProduct = false;
      } else {
        this.$message({
          type: "warning",
          message: "客户名称不能为空！"
        });
      }
    },
    // 步骤step点击
    stepClick(index) {
      if (index < this.productPagenum) {
        this.productPagenum = index;
      }
    },
    // 添加产品上一步
    preProductPage() {
      this.productPagenum--;
    },
    // 添加产品下一步
    nextProductPage() {
      this.$refs.productForm.validate(valid => {
        if (valid) {
          this.productPagenum++;
          // if (this.productPagenum == 1 && this.isEditProduct) {
          //   this.$nextTick(() => {
          //     this.$refs.fileInput.files =
          //       this.productForm.uuidFolder || this.productForm.uuidFile;
          //   });
          // }
        } else {
          return false;
        }
      });
    },
    // 创建时生成SN改变
    createSnChange(value) {
      if(value) return;
      this.$set(this.productForm, "snPrefix", "")
      this.$set(this.productForm, "snLen", "")
      this.$set(this.productForm, "startSn", "")
    },
    // 电量为整数,0-100
    minBattInput(value, formName, name) {
      // let newValue = this.$formatPositive(value);
      let newValue = value.replace(/[^\d]/g, "");
      if (newValue > 100) {
        newValue = 100;
      } else if (newValue <= 0) {
        newValue = 0;
      }
      this.$set(this[formName], name, newValue);
    },
    // 电池容量
    batteryInput(value, formName, name) {
      let newValue = value.replace(/[^\d]/g, "");
      if (newValue <= 0) {
        newValue = 0;
      }
      this.$set(this[formName], name, newValue);
    },
    // 确定添加产品
    checkProductSubmit() {
      this.$refs.productForm.validate(valid => {
        if (valid) {
          this.$confirm("确定完成该产品所有的配置信息吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            // 类别code, 型号id, 数量
            let { productType, productId } = this.productForm;
            // 类别title, 型号name
            let { productTypeTitle, productName } = {};
            this.pullDownData.productTypeList.forEach(item => {
              if (item.code == productType) productTypeTitle = item.title;
            });
            this.pullDownData.addProductList.forEach(item => {
              if (item.id == productId) productName = item.name;
            });
            // let _productIds = this.productTableData.map(item => item.productId);
            // if (_productIds.includes(productId)) {
            //   const _index = _productIds.indexOf(productId);
            //   this.$set(this.productTableData, _index, {
            //     productTypeTitle,
            //     productName,
            //     ...this.productForm,
            //     // swVersion: this.swVersion,
            //     // mcuVersion: this.mcuVersion
            //   });
            //   this.$set(this.dialogForm.products, _index, {
            //     ...this.productForm,
            //     // swVersion: this.swVersion,
            //     // mcuVersion: this.mcuVersion
            //   });
            // } else {
              this.productTableData.push({
                ...this.productForm,
                productTypeTitle,
                productName,
                // swVersion: this.swVersion,
                // mcuVersion: this.mcuVersion
              });
              this.dialogForm.products.push({
                ...this.productForm,
                // swVersion: this.swVersion,
                // mcuVersion: this.mcuVersion
              });
            // }
            this.productVisible = false;
          });
        } else {
          return false;
        }
      });
    },
    // 关闭添加产品
    closeCheckProduct() {
      this.productPagenum = 0;
      this.$refs.productForm.resetFields();
      this.productForm = {
        snPrefix: "AONI_",
        snLen: 5,
        onlyCarton: false,
        createSn: true
      };
      // this.swVersion = {
      //   mustIqc: true
      // };
      // this.mcuVersion = {};
    },
    // 修改已添加的产品
    editProduct(row) {
      this.productVisible = true;
      this.productForm = JSON.parse(JSON.stringify(row));
      // this.swVersion = this.productForm.swVersion;
      // this.mcuVersion = this.productForm.mcuVersion;
      this.isEditProduct = true;
      this.getProductList(this.productForm.productType, "addProductList");
      // this.getFirmwareList("Flash", "swVersionList");
      // this.getFirmwareList("MCU", "mcuVersionList");
    },
    // 移除添加的产品
    deleteProduct(e, row, index) {
      e.target.blur();
      // console.log(index)
      this.$confirm(`是否移除${row.productName}？`, "移除产品", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        this.productTableData.splice(index, 1);
        this.dialogForm.products.splice(index, 1);
      })
    },
    // 确认新建
    submitData(title) {
      this.$refs.dialogForm.validate(async valid => {
        if (valid) {
          // 前端调用SAP工单的search方法会报没权限，改为只在后端校验
          if (title == "新建销售订单") {
            const res = await apiCustomerOrderAdd({
              ...this.dialogForm
            });
            if (res.code == 0) {
              this.onSearch();
              this.$refs.myDialog.dialogVisible = false;
              this.$message({
                message: "新建成功",
                type: "success"
              });
            } else if(res.code == 1024) {
              this.onSearch();
              this.$refs.myDialog.dialogVisible = false;
              this.$message({
                message: res.msg,
                type: "success"
              });
            }
          }
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = { products: [] };
      this.productTableData = [];
    },
    onlyMyChange() {
        this.getCustomerOrderSearch();
    },
    // 清除查询
    onClear() {
      this.searchConditionForm = {};
      this.pullDownData.productList = [];
      this.getCustomerOrderSearch();
    },
    // 确认查询
    onSearch() {
      this.pagination.currentPage = 1;
      this.getCustomerOrderSearch();
    },
    // 查询条件-产品类别改变
    productTypeChange(value) {
      this.$set(this.searchConditionForm, "productId", null);
      this.pullDownData.productList = [];
      if (value) {
        this.getProductList(value, "productList");
      }
    },
    // 查询条件-下单开始时间
    startDateChange() {
      let { startDate, endDate } = this.searchConditionForm;
      if (startDate > endDate) {
        this.searchConditionForm.endDate = this.searchConditionForm.startDate;
      }
    },
    // 查询条件-下单结束时间
    endDateChange() {
      let { startDate, endDate } = this.searchConditionForm;
      if (startDate > endDate) {
        this.searchConditionForm.startDate = this.searchConditionForm.endDate;
      }
    },
    // 新建订单-产品类别改变
    addProductTypeChange(value) {
      this.$set(this.productForm, "productId", undefined);
      this.pullDownData.addProductList = [];
      if (value) {
        this.getProductList(value, "addProductList");
      }
    },
    // 新建订单-产品型号改变
    async productIdChange(value) {
      // this.swVersion = {
      //   mustIqc: true
      // };
      // this.mcuVersion = {};
      this.pullDownData.addProductList.forEach(item => {
        if (item.id == value) {
          this.p2pType = item.p2pType;
          this.$set(this.productForm, "tuyaPid", item.tuyaPid);
          if (item.p2pType != "DLink") {
            this.$set(this.productForm, "partNumber", undefined);
            this.$set(this.productForm, "pickSlip", undefined);
            this.$set(this.productForm, "hqPo", undefined);
          }
          this.wakeup = item.wakeup;
          if (!item.wakeup) {
            this.$set(this.productForm, "battery", undefined);
          }
        }
      });
      if (!value) return false;
      // this.getFirmwareList("Flash", "swVersionList");
      // this.getFirmwareList("MCU", "mcuVersionList");
    },
    // 输入框只能输入数字
    onlyNumber(value, formName, name) {
      this.$set(this[formName], name, this.$formatPositive(value));
    },
    // 输入框只能输入小数
    onlyDecimals(value, formName, name) {
      this.$set(this[formName], name, this.$formatDecimals(value));
    },
    // 弹框选择
    selectVisible(value, orderName, labelName, origin) {
      if (value) {
        // console.log(orderName, labelName)
        this.$refs.orderTableSelect.orderName = orderName;
        this.$refs.orderTableSelect.labelName = labelName;
        this.$refs.orderTableSelect.origin = origin;
        this.$refs.orderTableSelect.openDialog();
      }
    },
    // 弹框表格提交
    orderTableSubmit({ orderName, selectRow, origin }) {
      if (origin == "add") {
        this.$set(this.dialogForm, `${orderName + "Id"}`, selectRow.id);
        this.$set(this.pullDownData, `${orderName + "AddList"}`, [selectRow]);
      } else {        
        this.$set(this[origin], `${orderName + "Id"}`, selectRow.id);
        this.$set(this.pullDownData, `${orderName + "List"}`, [selectRow]);
      }
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getCustomerOrderSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getCustomerOrderSearch();
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getCustomerOrderSearch();
    },
    // 表格行合并
    objectSpanMethod({ row, columnIndex }) {
      // columnIndex: 1-3列需要合并
      if (columnIndex >= 1 && columnIndex <= 4) {
        if (row.rowspan) {
          return {
            // 几行合一
            rowspan: row.rowspan,
            // 几列合一
            colspan: 1
          };
        } else {
          return {
            // 为0不合,且该单元格会消失
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    // 表格列允许跳转
    clickAllowSkip(row) {
      this.nowRowData = row;
      this.$refs.detailPage.dialogVisible = true;
    },
    // 客户名称下拉
    async getCustomerList() {
      const res = await apiCustomerList();
      if (res.code == 0) {
        this.pullDownData.customerList = res.data;
      }
    },
    // 产品类别下拉
    async getProductTypeList() {
      const res = await apiProductTypeList();
      if (res.code == 0) {
        this.pullDownData.productTypeList = res.data;
      }
    },
    // 产品型号下拉
    async getProductList(productType, name) {
      const res = await apiProductList({
        productType
      });
      if (res.code == 0) {
        this.pullDownData[name] = res.data;
      }
    },
    // 订单状态下拉
    async getOrderStatusList(productType) {
      const res = await apiOrderStatusList({
        productType
      });
      if (res.code == 0) {
        this.pullDownData.statusList = res.data;
      }
    },
    // 固件列表
    // async getFirmwareList(type, listName) {
    //   const res = await apiFirmwareList({
    //     customerId: this.dialogForm.customerId,
    //     productId: this.productForm.productId,
    //     type
    //   });
    //   if (res.code == 0) {
    //     this.pullDownData[listName] = res.data;
    //   }
    // },
    callback() {
      this.getCustomerList();
      this.getProductTypeList();
      this.getOrderStatusList();
    }
  },
  activated() {
    window.onresize = () => {
      document.querySelector(".contentBox").style.top =
        document.querySelector(".header").offsetHeight + "px";
    };
    this.getCustomerOrderSearch("", this.callback);
  },
  deactivated() {
    window.onresize = null;
  }
};
</script>

<style lang="less" scoped>
.customerOrder {
  .productTable {
    /deep/.el-table__header-wrapper {
      line-height: 0;
      th {
        padding: 4px 0;
      }
    }
  }
}
</style>